<template>
  <div class="text-13 h-6 flex items-center">{{ $t('evaluate_editor.crypto-jwt-decode') }}</div>
</template>

<script>
export default {
  name: 'JWTDecodeOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    payload() {
      return this.item.payload;
    },
  },
};
</script>
